import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { gsap } from "gsap";

export default function LoadingScreen({
    finish = false,
    onDone = () => { },
    logoSrc,
    brandName = "LSC PRODUTORA",
}) {
    const rootRef = useRef(null);
    const logoRef = useRef(null);
    const pulseRef = useRef(null);

    // trava scroll enquanto loading
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, []);

    // animação “idle” (pulsando)
    useEffect(() => {
        if (!logoRef.current) return;

        pulseRef.current = gsap.to(logoRef.current, {
            scale: 1.06,
            duration: 0.9,
            yoyo: true,
            repeat: -1,
            ease: "power1.inOut",
        });

        return () => {
            if (pulseRef.current) pulseRef.current.kill();
        };
    }, []);

    // animação de saída (zoom-in da logo preenchendo a tela)
    useEffect(() => {
        if (!finish) return;
        const root = rootRef.current;
        const logo = logoRef.current;
        if (!root || !logo) return;

        // para o “idle”
        if (pulseRef.current) pulseRef.current.kill();

        const tl = gsap.timeline({
            defaults: { ease: "power3.inOut" },
            onComplete: onDone,
        });

        // dá um “impacto” antes do zoom
        tl.to(logo, { scale: 1.12, duration: 0.12, ease: "power2.out" });

        // zoom-in forte até preencher tudo
        tl.to(logo, {
            scale: 26,
            duration: 0.8,
            ease: "power3.in",
        });

        // some com o overlay (rápido)
        tl.to(
            root,
            {
                opacity: 0,
                duration: 0.22,
                ease: "power2.out",
            },
            "-=0.10"
        );

        return () => tl.kill();
    }, [finish, onDone]);

    return (
        <Box
            ref={rootRef}
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 20000,
                bgcolor: "var(--verdeClaro)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
            }}
        >
            {/* LOGO CENTRO */}
            <Box
                component="img"
                ref={logoRef}
                src={logoSrc}
                alt="Logo"
                sx={{
                    width: { xs: 86, md: 96 },
                    height: "auto",
                    transformOrigin: "50% 50%",
                    // deixa a logo preta mesmo se o arquivo não for preto
                    filter: "brightness(0) saturate(100%)",
                    userSelect: "none",
                    pointerEvents: "none",
                }}
            />

            {/* NOME EMBAIXO */}
            <Typography
                sx={{
                    position: "absolute",
                    bottom: { xs: 18, md: 22 },
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontWeight: 900,
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    fontSize: 11,
                    color: "rgba(0,0,0,0.85)",
                    userSelect: "none",
                }}
            >
                {brandName}
            </Typography>
        </Box>
    );
}